<template>
  <div style="padding-bottom: 5px">
    <div ref="imgbox">
      <Upload
          ref="upload"
          :show-upload-list="false"
          multiple
          :before-upload="handleUpload"
          :on-success="loadfile"
          :action="actionUrl"
          :headers="uploadHeaders"
          :style="uploadStyle"
      >
        <div class="file-upload-box">
          <Icon v-if="!imgUrl" type="md-add" size="20"></Icon>
          <img v-else-if="fileType === 'img'" :src="imgUrl" :style="uploadStyle"/>
          <div v-else>{{fileType}}</div>
        </div>
      </Upload>
    </div>
  </div>
</template>

<script>
  import auth from "@/utils/auth";
  import {isNotEmpty} from "@/utils/util";

  const assign = (o) => Object.assign({}, o);
  const empties = [undefined, "", null, "null", {}, []];

  export default {
    name: "UploadOneImg",
    props: {
      uploadStyle: {
        type: String,
        default: "width:56px; height:56px;",
      },
      initImgUrl: {
        type: String,
        default: "",
      },
      initFileName: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        addIcon: "",
        imgUrl: "",
        fileName: "",
        actionUrl: "", // 初始化上传地址
        uploadHeaders: {
          Authorization: auth.getAuth().token,
          token: auth.getAuth().token,
        },
      };
    },
    computed:{
      fileType(){
        if (isNotEmpty(this.imgUrl)) {
          if (this.imgUrl.indexOf(".xls") > -1) {
            return "xls文件"
          }else if (this.imgUrl.indexOf(".pdf") > -1){
            return "pdf文件"
          }else if (this.imgUrl.indexOf(".png") > -1 || this.imgUrl.indexOf(".jpg") > -1 || this.imgUrl.indexOf(".jpeg") > -1) {
            return "img"
          }else{
            return "文件"
          }
        }
        return "";
      }
    },
    watch: {
      initImgUrl: {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.imgUrl = empties.includes(val) ? this.addIcon : val;
        },
      },
    },
    mounted() {
      this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
    },
    methods: {
      handleUpload(file) {
        this.file = file;
        let that = this;
        let reader = new FileReader();
        reader.onload = function (e) {
          that.imgUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      },
      loadfile(res) {
        if (res && res.status === 200 && res.data) {
          this.fileName = res.data.oldName
          this.imgUrl = res.data.url;
          this.changeFile();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      changeFile() {
        this.$emit("change", this.imgUrl, this.fileName);
      },
      reset() {
        this.addIcon = '';
        this.imgUrl = '';
        this.fileName = ''
      }
    },
  };
</script>
<style>
  .file-upload-box {
    height: 56px;
    width: 56px;
    line-height: 56px;
    border: 1px dashed #dcdee2;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    display: inline-block;
  }
</style>